module.exports = __webpack_public_path__ + "static/img/btn_bgc_2.8300586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latast_pc/btn_bgc_2.png
// module id = TUuL
// module chunks = 98